import $ from 'jquery';

const slideNotice = (container, element) => {
  const ele = `<${element || 'li'}/>`;

  function add(id, text, cb) {
    if ($(`#${id}`).length === 0) {
      $(ele)
        .attr('id', id)
        .html(text)
        .hide()
        .appendTo(container)
        .slideDown(() => {
          if (typeof cb === 'function') cb();
        });
    }
  }

  function remove(id, cb) {
    $(container)
      .find(`#${id}`)
      .slideUp(function () {
        $(this).remove();
        if (typeof cb === 'function') cb();
      });
  }

  return {
    add,
    remove,
  };
};

export default slideNotice;
